module.exports = __webpack_public_path__ + "static/media/icon-add-media.370a2fee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/MessageForm/icon-add-media.svg
// module id = 485
// module chunks = 1